import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNoFlash: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="no-flash"><path fillRule="evenodd" clipRule="evenodd" d="M14.0019 0.238037V7.99989H21.7461L16.5141 15.0217L21.7484 19.6902L20.75 20.8096L2.25 4.30963L3.24842 3.19019L8.38728 7.77349L14.0019 0.238037ZM9.51107 8.77579L15.3903 14.0194L18.7578 9.49989H12.5019V4.76173L9.51107 8.77579Z" fill="currentColor"/><path d="M13.5918 16.4332L14.7156 17.4355L10.0019 23.7617V15.9999H2.25781L6.58878 10.1873L7.71257 11.1896L5.24606 14.4999H11.4241L11.5019 14.5693V19.238L13.5918 16.4332Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNoFlash;
